import { audiogramMessages } from '@app/modules/admin/screens/fragments/manage/audiogram/messages';
import { MessageDescriptor } from 'react-intl';

export type AudiogramVariant = {
  value: string;
  message: MessageDescriptor;
};

export const AUDIOGRAM_TARGET_VARIANTS: AudiogramVariant[] = [
  { value: '1x1', message: audiogramMessages.formatSquare },
  { value: '16x9', message: audiogramMessages.formatHorizontal },
  { value: '9x16', message: audiogramMessages.formatVertical },
];
